import { render, staticRenderFns } from "./ToDoInput.vue?vue&type=template&id=21ecb097&scoped=true&"
import script from "./ToDoInput.vue?vue&type=script&lang=js&"
export * from "./ToDoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ecb097",
  null
  
)

export default component.exports